module.exports = __webpack_public_path__ + "img/bg1.d8386829.png";